import script from "./FranceGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./FranceGuide.vue?vue&type=script&lang=ts&setup=true"

import "./FranceGuide.vue?vue&type=style&index=0&id=6d9c7a33&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9c7a33"]])

export default __exports__